import { render, staticRenderFns } from "./NewSplashPage.vue?vue&type=template&id=d9568d96&scoped=true&"
import script from "./NewSplashPage.vue?vue&type=script&lang=js&"
export * from "./NewSplashPage.vue?vue&type=script&lang=js&"
import style0 from "./NewSplashPage.vue?vue&type=style&index=0&id=d9568d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9568d96",
  null
  
)

export default component.exports